<!-- <div id="main" style="width: 100%; height: 150px"></div> -->
<div echarts [options]="options" class="demo-charts"></div>
